import type { BulkActionResult } from './bulkTagTypes';

type FailureEntry = BulkActionResult['failures'][number];

export function getFailedIdsText(failures: Array<FailureEntry>) {
  return failures.map((failure) => failure.offerId).join('\n');
}

export function getFailedIdsWithReasonsText(failures: Array<FailureEntry>) {
  return failures.map((failure) => `${failure.offerId} - ${failure.reason}`).join('\n');
}
